import { get, logWithAmplitude, post, throwHttpError } from './api';

export interface ManiaLocation {
    _id: string;
    title: string;
    cityState: string;
    website: string | null;
    tag: string;
    lat: number;
    lng: number;
    markerTitle: string;
    day?: string; // ISO 8601 date string (UTC)
}

export interface LeadSubmission {
    email?: string;
    name?: string;
    message?: string;
    source?: string;
    additional_data?: { [key: string]: string };
}

export interface LeadResponse {
    success: boolean;
    message: string;
}

/**
 * Get all mania locations
 */
export async function getManiaLocations(amplitude_callsite: string): Promise<ManiaLocation[]> {
    const response = await fetch('/api/game/mania-locations', get());

    if (!response.ok) {
        await throwHttpError('An error occurred while getting mania locations.', response);
    }

    logWithAmplitude(amplitude_callsite, 'Get Mania Locations', {});

    return await (response.json() as Promise<ManiaLocation[]>);
}

/**
 * Get the current mania location (for today)
 */
export async function getCurrentManiaLocation(amplitude_callsite: string): Promise<ManiaLocation | null> {
    const response = await fetch('/api/game/mania-locations/current', get());

    if (!response.ok) {
        await throwHttpError('An error occurred while getting current mania location.', response);
    }

    logWithAmplitude(amplitude_callsite, 'Get Current Mania Location', {});

    return await (response.json() as Promise<ManiaLocation | null>);
}

/**
 * Submit a lead/interest form
 */
export async function submitLead(amplitude_callsite: string, lead: LeadSubmission): Promise<LeadResponse> {
    const response = await fetch('/api/game/submit-lead', post(lead));

    if (!response.ok) {
        await throwHttpError('An error occurred while submitting lead.', response);
    }

    logWithAmplitude(amplitude_callsite, 'Submit Lead', {
        source: lead.source,
        has_email: !!lead.email,
        has_name: !!lead.name,
    });

    return await (response.json() as Promise<LeadResponse>);
}
